import { render, staticRenderFns } from "./PeopleData.vue?vue&type=template&id=4f4cc8dc&scoped=true&"
import script from "./PeopleData.vue?vue&type=script&lang=js&"
export * from "./PeopleData.vue?vue&type=script&lang=js&"
import style0 from "./PeopleData.vue?vue&type=style&index=0&id=4f4cc8dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4cc8dc",
  null
  
)

export default component.exports